import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {
  IPlatformToolComponent,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {PlatformCommandResponse} from '@shared/commands/command-base';

@Component({
    standalone: false,
    selector: 'app-platform-tool-treaty-document-wrapper-content',
  templateUrl: './platform-tool-treaty-document-wrapper-content.component.html',
  styleUrls: ['./platform-tool-treaty-document-wrapper-content.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PlatformToolTreatyDocumentWrapperContentComponent implements OnInit, OnDestroy, IPlatformToolComponent {

  handler: IPlatformToolHandler;
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  selectedTab: TabModel;
  constructor() { }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }

  onAfterExecuteNextCommand(nextCommandResponse: PlatformCommandResponse) {
  }

  onAfterExecutePreviousCommand(previousCommandResponse: PlatformCommandResponse) {
  }

  onBeforeExecuteNextCommand(): boolean {
    return false;
  }

  onBeforeExecutePreviousCommand(): boolean {
    return false;
  }

  onLoad() {
  }

}
